import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  updateAccountForm,
  saveAccountInfo,
  getAccountInfo,
  logOutUser,
  logoutSession,
  testSessionAuth,
} from "../../actions";
import { Dropdown, Spinner } from "react-bootstrap";
import history from "../../../History";
import * as ROUTES from "../../../constants/routes";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { auth } from "../../../services/firebase";
import { Link } from "react-router-dom";
import {
  clearApplicationContext,
  setApplicationContext,
  setContextReturnURL,
} from "../../actions/ApplicationContextActions";
import {
  FIREBASE_AUTH,
  SAVE_ACCOUNT_INFO_FAILURE,
  SESSION_AUTH,
} from "../../../constants/types";
import { FiAlertCircle } from "react-icons/fi";
import {
  saveBusinessDetails,
  updateBusinessForm,
} from "../../actions/BusinessActions";
import { parseError } from "../../actions/ActionHelpers";
import { isValidPhoneNumber } from "../common/helpers";

const AccountInfoForm = (props) => {
  const [errors, setErrors] = useState({});

  useEffect(() => {
    props
      .testSessionAuth()
      .then((res) => {
        const {
          full_name,
          phone_number,
          business_name,
          business_website,
          monthly_avg_shipment,
        } = props.info;
        props.updateAccountForm({
          full_name,
          phone_number,
          business_name,
          business_website,
          monthly_avg_shipment,
        });
        const {
          referral_source,
          other_referral_text,
          monthly_local_order_volume,
          monthly_international_order_volume,
        } = props.businessDetails;
        props.updateBusinessForm({
          referral_source,
          other_referral_text,
          monthly_local_order_volume,
          monthly_international_order_volume,
        });
      })
      .catch((err) => {
        console.log(err);
        history.replace(ROUTES.SIGN_IN);
      });
  }, []);

  useEffect(() => {
    let errorData = {};
    if (
      props.errors &&
      typeof props.errors === "object" &&
      !Array.isArray(props.errors) &&
      Object.keys(props.errors).length > 0
    ) {
      Object.keys(props.errors).forEach((field) => {
        const message = Array.isArray(props.errors[field])
          ? props.errors[field][0]
          : props.errors[field];
        if (Object.keys(props.form).includes(field)) {
          errorData[field] = message;
        } else if (field === "first_name" || field === "last_name") {
          errorData.full_name = message;
        }
      });
    }
    if (
      props.businessErrors &&
      typeof props.businessErrors === "object" &&
      !Array.isArray(props.businessErrors) &&
      Object.keys(props.businessErrors).length > 0
    ) {
      Object.keys(props.businessErrors).forEach((field) => {
        if (Object.keys(props.businessForm).includes(field)) {
          const message = Array.isArray(props.businessErrors[field])
            ? props.businessErrors[field][0]
            : props.businessErrors[field];
          errorData[field] = message;
        }
      });
    }
    setErrors(errorData);
  }, [props.errors, props.businessErrors]);

  const validateInputs = (form) => {
    let valid = true;
    const errorData = {};

    const full_name = form.full_name ? form.full_name.trim() : "";

    if (full_name === "") {
      errorData.full_name = "Full Name cannot be empty";
      valid = false;
    }
    if (full_name.indexOf(" ") === -1) {
      errorData.full_name = "Please use your full name";
      valid = false;
    }

    if (!isValidPhoneNumber(form.phone_number)) {
      errorData.phone_number = "Please enter a valid phone number";
      valid = false;
    }

    if (!form.business_name || form.business_name.toString().trim() === "") {
      errorData.business_name = "Business Name cannot be empty";
      valid = false;
    }
    if (
      !form.business_website ||
      form.business_website.toString().trim() === ""
    ) {
      errorData.business_website = "Business Website cannot be empty";
      valid = false;
    }
    if (
      !form.monthly_avg_shipment ||
      form.monthly_avg_shipment.toString().trim() === ""
    ) {
      errorData.monthly_avg_shipment =
        "Monthly Average Shipments cannot be empty";
      valid = false;
    }

    setErrors(errorData);
    return valid;
  };
  const validateBusinessInputs = (form) => {
    let valid = true;
    const errorData = { ...errors };

    if (!form.referral_source?.toString().trim()) {
      errorData.referral_source = "Referral Source cannot be empty";
      valid = false;
    } else if (
      form.referral_source === "other" &&
      !form.other_referral_text?.toString().trim()
    ) {
      errorData.referral_source = "Please share where you heard about us";
      valid = false;
    }

    if (!form.monthly_local_order_volume?.toString().trim()) {
      errorData.monthly_local_order_volume = "Please select one of the options";
      valid = false;
    }
    if (!form.monthly_international_order_volume?.toString().trim()) {
      errorData.monthly_international_order_volume =
        "Please select one of the options";
      valid = false;
    }

    setErrors(errorData);
    return valid;
  };

  const handleSubmit = () => {
    const { form, businessForm } = props;

    if (validateInputs(form) && validateBusinessInputs(businessForm)) {
      const {
        referral_source,
        other_referral_text,
        monthly_local_order_volume,
        monthly_international_order_volume,
      } = props.businessForm;
      props.saveAccountInfo(form, () => {
        props.saveBusinessDetails(
          {
            referral_source,
            other_referral_text:
              referral_source === "other" ? other_referral_text : undefined,
            monthly_local_order_volume,
            monthly_international_order_volume,
          },
          () => {
            if (props.context.actionType !== "edit") {
              history.replace(ROUTES.BANK_ACCOUNT_DETAILS);
              return;
            }

            if (props.returnURL && props.returnURL.trim() !== "") {
              history.replace(props.returnURL);
              props.clearApplicationContext();
              return;
            }
            history.replace(ROUTES.HOME);
          },
        );
      });
    }
  };

  const renderMonthlyLocalOrders = () => {
    const MONTHLY_LOCAL_ORDERS = {
      _0_to_50: "1-50",
      _51_to_150: "51-150",
      _151_to_450: "151-450",
      _451_and_above: "451+",
    };

    const list = Object.keys(MONTHLY_LOCAL_ORDERS).map((item, idx) => {
      return (
        <Dropdown.Item
          key={idx}
          onClick={() => {
            setErrors({});
            props.updateBusinessForm({ monthly_local_order_volume: item });
          }}
        >
          {MONTHLY_LOCAL_ORDERS[item]}
        </Dropdown.Item>
      );
    });
    return (
      <Dropdown className="">
        <Dropdown.Toggle className="col-12 p-0 d-flex justify-content-between align-items-center px-3">
          {props.businessForm.monthly_local_order_volume ? (
            MONTHLY_LOCAL_ORDERS[props.businessForm.monthly_local_order_volume]
          ) : (
            <p className={"placeholder"}>Select an Option</p>
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu>{list}</Dropdown.Menu>
      </Dropdown>
    );
  };

  const renderReferralSource = () => {
    const REFERRAL_SOURCES = {
      instagram: "Instagram",
      facebook: "Facebook",
      tiktok: "TikTok",
      google_search: "Google Search",
      whatsapp: "WhatsApp",
      friend_or_business: "Friend or Business",
      event_or_popup: "Event or Popup",
      other: "Other",
    };

    const list = Object.keys(REFERRAL_SOURCES).map((item, idx) => {
      return (
        <Dropdown.Item
          key={idx}
          onClick={() => {
            setErrors({});
            const referral_data = { referral_source: item };
            if (item !== "other") {
              referral_data.other_referral_text = "";
            }
            props.updateBusinessForm({ ...referral_data });
          }}
        >
          {REFERRAL_SOURCES[item]}
        </Dropdown.Item>
      );
    });
    return (
      <Dropdown className="">
        <Dropdown.Toggle className="col-12 p-0 d-flex justify-content-between align-items-center px-3">
          {props.businessForm.referral_source ? (
            REFERRAL_SOURCES[props.businessForm.referral_source]
          ) : (
            <p className={"placeholder"}>Select an Option</p>
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu>{list}</Dropdown.Menu>
      </Dropdown>
    );
  };

  const renderMonthlyInternationalOrders = () => {
    const MONTHLY_INTERNATIONAL_ORDERS = {
      _0_to_5: "0-5",
      _6_to_10: "6-10",
      _11_to_30: "11-30",
      _31_and_above: "31+",
    };

    const list = Object.keys(MONTHLY_INTERNATIONAL_ORDERS).map((item, idx) => {
      return (
        <Dropdown.Item
          key={idx}
          onClick={() => {
            setErrors({});
            props.updateBusinessForm({
              monthly_international_order_volume: item,
            });
          }}
        >
          {MONTHLY_INTERNATIONAL_ORDERS[item]}
        </Dropdown.Item>
      );
    });
    return (
      <Dropdown className="">
        <Dropdown.Toggle className="col-12 p-0 d-flex justify-content-between align-items-center px-3">
          {props.businessForm.monthly_international_order_volume ? (
            MONTHLY_INTERNATIONAL_ORDERS[
              props.businessForm.monthly_international_order_volume
            ]
          ) : (
            <p className={"placeholder"}>Select an Option</p>
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu>{list}</Dropdown.Menu>
      </Dropdown>
    );
  };

  const handleEnter = (event) => {
    const form = event.target.parentNode.parentNode.childNodes;
    const index = [...form].indexOf(event.target.parentNode);
    if (
      event.key.toLowerCase() === "enter" ||
      event.key.toLowerCase() === "arrowdown"
    ) {
      if (index !== 2) form[index + 1].focus();
      else {
        form[index + 1].querySelector("input").focus();
      }
      event.preventDefault();
    } else if (event.key.toLowerCase() === "arrowup") {
      if (index !== 4) form[index - 1].focus();
      else {
        form[index - 1].querySelector("input").focus();
      }
      event.preventDefault();
    }
  };

  return (
    <>
      <h3>Profile Details</h3>

      {Object.keys(props.errors).length > 0 ? (
        <div className={"error-block"}>
          <FiAlertCircle />
          <p>{parseError(props.errors)}</p>
        </div>
      ) : null}
      <div
        className={
          "form col-12 d-flex flex-column align-items-center text-left"
        }
      >
        <label
          className={`col-12 p-0 d-flex flex-column ${errors.full_name ? "error" : ""}`}
        >
          Full Name
          <input
            placeholder={"Enter your full name"}
            value={props.form.full_name}
            onChange={(e) => {
              setErrors({});
              props.updateAccountForm({ full_name: e.target.value });
            }}
            onKeyDown={handleEnter}
          />
          <p className={"error"}>{errors.full_name}</p>
        </label>
        <label
          className={`col-12 p-0 d-flex flex-column ${errors.business_name ? "error" : ""}`}
        >
          Business Name
          <input
            placeholder={"Enter your business name"}
            value={props.form.business_name}
            onChange={(e) => {
              setErrors({});
              props.updateAccountForm({ business_name: e.target.value });
            }}
            onKeyDown={handleEnter}
          />
          <p className={"error"}>{errors.business_name}</p>
        </label>
        <label
          className={`col-12 p-0 d-flex flex-column ${errors.business_website ? "error" : ""}`}
        >
          Business Website
          <input
            placeholder={"Enter your business website"}
            value={props.form.business_website}
            onChange={(e) => {
              setErrors({});
              props.updateAccountForm({ business_website: e.target.value });
            }}
            onKeyDown={handleEnter}
          />
          <p className={"error"}>{errors.business_website}</p>
        </label>
        <label
          className={`col-12 p-0 d-flex flex-column ${errors.phone_number ? "error" : ""}`}
        >
          Phone Number
          <PhoneInput
            country={"ke"}
            className={""}
            value={props.form.phone_number}
            onChange={(phone) => {
              setErrors({});
              props.updateAccountForm({ phone_number: phone });
            }}
            placeholder={"Enter your phone number"}
            enableTerritories
          />
          <p className={"error"}>{errors.phone_number}</p>
        </label>
        {props.context.actionType !== "edit" && (
          <label
            className={`col-12 p-0 d-flex flex-column ${errors.referral_source ? "error" : ""}`}
          >
            Where did you hear about ShipShap?
            {renderReferralSource()}
            {props.businessForm.referral_source === "other" ? (
              <input
                className=""
                type="text"
                placeholder={"Enter your business website"}
                onKeyDown={handleEnter}
                value={props.businessForm.other_referral_text}
                onChange={(e) =>
                  props.updateBusinessForm({
                    other_referral_text: e.target.value,
                  })
                }
              />
            ) : null}
            <p className={"error"}>{errors.referral_source}</p>
          </label>
        )}
        {props.context.actionType !== "edit" && (
          <label
            className={`col-12 p-0 d-flex flex-column ${errors.monthly_local_order_volume ? "error" : ""}`}
          >
            How many orders do you ship locally (per month)?
            {renderMonthlyLocalOrders()}
            <p className={"error"}>{errors.monthly_local_order_volume}</p>
          </label>
        )}
        {props.context.actionType !== "edit" && (
          <label
            className={`col-12 p-0 d-flex flex-column ${errors.monthly_international_order_volume ? "error" : ""}`}
          >
            How many orders do you ship Internationally (per month)
            {renderMonthlyInternationalOrders()}
            <p className={"error"}>
              {errors.monthly_international_order_volume}
            </p>
          </label>
        )}
      </div>
      <div
        className={
          "buttons col-12 d-flex flex-column align-items-center text-left"
        }
      >
        <button onClick={handleSubmit} disabled={props.loading}>
          {props.loading ? (
            <Spinner animation={"border"} variant={"light"} />
          ) : (
            "Continue"
          )}
        </button>
        {props.context.actionType === "edit" ? (
          <a
            className={"logoutButton"}
            onClick={() => {
              if (props.context.actionType === "edit") {
                history.goBack();
              } else {
                history.replace(props.returnURL);
              }
              props.clearApplicationContext();
            }}
          >
            Cancel
          </a>
        ) : (
          <a
            onClick={() => {
              if (props.context.auth === FIREBASE_AUTH) props.logOutUser();
              else props.logoutSession();
            }}
            className={"logoutButton"}
          >
            Log out
          </a>
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({
  userDetails,
  accountForm,
  businessDetailsForm,
  businessDetails,
  applicationContext,
}) => ({
  form: accountForm,
  businessForm: businessDetailsForm,
  loading: accountForm.loading,
  errors: accountForm.errors,
  businessLoading: businessDetailsForm.loading,
  businessErrors: businessDetailsForm.errors,
  info: userDetails.info,
  businessDetails: businessDetails.details,
  returnURL: applicationContext.context.returnURL,
  context: applicationContext.context,
});

export default connect(mapStateToProps, {
  updateAccountForm,
  updateBusinessForm,
  saveAccountInfo,
  saveBusinessDetails,
  getAccountInfo,
  logOutUser,
  setContextReturnURL,
  setApplicationContext,
  clearApplicationContext,
  logoutSession,
  testSessionAuth,
})(AccountInfoForm);
